import { BATCH_CHANGE, CHANGE } from "./types";

export function change(path, value) {
    return { type: CHANGE, payload: { path, value } };
}

export function batchChange(changes) {
    return { type: BATCH_CHANGE, payload: { changes } };
}
